export interface Riddle {
    question: string;
    answer: string;
    options?: string[];
    clue: string;
}

export function shuffleOptions(options: string[] | undefined): string[] | undefined {
    if (options) {
        for (let i: number = options.length - 1; i > 0; i--) {
            const j: number = Math.floor(Math.random() * (i + 1));
            [options[i], options[j]] = [options[j], options[i]];
        }
    }
    return options;
}

export function shuffleRiddles(riddles: Riddle[]): Riddle[] {
    for (let i: number = riddles.length - 1; i > 0; i--) {
        const j: number = Math.floor(Math.random() * (i + 1));
        [riddles[i], riddles[j]] = [riddles[j], riddles[i]];
        riddles[i].options = shuffleOptions(riddles[i].options);
        riddles[j].options = shuffleOptions(riddles[j].options);
    }
    return riddles;
}

export let riddles: Riddle[] = [
    {
        question: "What has keys but can't open locks?",
        answer: "Piano",
        options: ["Piano", "Drums", "Guitar"],
        clue: "It's a stringed instrument"
    },
    { 
        question: "I speak without a mouth and hear without ears. I have no body, but I come alive with wind. What am I?",
        answer: "Echo",
        options: ["Echo", "Voice", "Whisper"],
        clue: "It's a reflection of sound"
    },
    { 
        question: "What has one eye but can't see?",
        answer: "Needle",
        options: ["Needle", "Cyclops", "Telescope"],
        clue: "It's used for stitching"
    },
    { 
        question: "The more you take, the more you leave behind. What am I?",
        answer: "Footsteps",
        options: ["Footsteps", "Money", "Time"],
        clue: "It's left on the ground as you walk"
    },
    { 
        question: "What has a head, a tail, is brown, and has no legs?",
        answer: "Penny",
        options: ["Penny", "Dog", "Snake"],
        clue: "It's a form of currency"
    },
    { 
        question: "What is always in front of you but can't be seen?",
        answer: "Future",
        options: ["Future", "Air", "Dreams"],
        clue: "It's what is yet to happen"
    },
    { 
        question: "What comes once in a minute, twice in a moment, but never in a thousand years?",
        answer: "Letter 'm'",
        options: ["Letter 'm'", "Number '2'", "Time"],
        clue: "Think about linguistic patterns"
    },
    { 
        question: "What has a neck but no head?",
        answer: "Bottle",
        options: ["Bottle", "Giraffe", "River"],
        clue: "It's a container for liquids"
    },
    { 
        question: "What belongs to you, but other people use it more than you do?",
        answer: "Your name",
        options: ["Your name", "Your phone", "Your house"],
        clue: "It's a personal identifier"
    },
    { 
        question: "What has a bed but never sleeps?",
        answer: "River",
        options: ["River", "Hotel", "Nest"],
        clue: "It flows but doesn't rest"
    },
    { 
        question: "What has cities but no houses, forests but no trees, and rivers but no water?",
        answer: "Map",
        options: ["Map", "Globe", "Atlas"],
        clue: "It represents geographical features"
    },
    { 
        question: "What can travel around the world while staying in a corner?",
        answer: "Stamp",
        options: ["Stamp", "Airplane", "Internet"],
        clue: "It's a small adhesive label"
    },
    { 
        question: "What has a head and a tail but no body?",
        answer: "Coin",
        options: ["Coin", "Snake", "Fish"],
        clue: "It's used as currency"
    },
    { 
        question: "What has teeth but cannot bite?",
        answer: "Comb",
        options: ["Comb", "Dog", "Crocodile"],
        clue: "It's used for grooming"
    },
    { 
        question: "What has hands but cannot clap?",
        answer: "Clock",
        options: ["Clock", "Monkey", "Gorilla"],
        clue: "It tells time"
    },
    { 
        question: "What has a heart that doesn’t beat?",
        answer: "Artichoke",
        options: ["Artichoke", "Robot", "Statue"],
        clue: "It's a type of vegetable"
    },
    { 
        question: "What runs but cannot walk?",
        answer: "River",
        options: ["River", "Car", "Horse"],
        clue: "It flows continuously"
    },
    { 
        question: "What has eyes but can't see?",
        answer: "Potato",
        options: ["Potato", "Spider", "Owl"],
        clue: "It's a starchy tuber"
    }
];
riddles = shuffleRiddles(riddles);
